
import store from '@/serviforms/designer/store';
import { updatePages, getAllPages, getQuestionsByPage, getAllQuestion } from "@/serviforms/designer/indexDB/logic.js";

const fixPositionQestionsActions = async () => {
    const getPages = await getAllPages()
    const allQuestions = await getAllQuestion()
    let allPromise = []
    let returnPages = []
    for (const i in getPages) {
        const { questions, key } = getPages[i]
        const exist = questions.some(item => item.inputType === 'action' && item.type === 'label')

        if (exist) {
            getPages[i] = getQuestionsAction(questions, allQuestions)
            returnPages = [...returnPages, ...getPages[i]]
            allPromise.push(updatePages(key, getPages[i]))
        }else returnPages = [...returnPages, ...questions]
    }

    await Promise.all(allPromise)
    // deleteHelper(returnPages)
    resetActionsPageCurrent()
    return returnPages

}

const getQuestionsAction = (questions, allQuestions) => {
    for (const i in questions) {
        const { inputType, type, name: _name } = questions[i]
        if (inputType === 'action' && type === 'label') {
            const indiceFather = allQuestions.findIndex(({name}) => name === _name)
            questions[i].actions.questions = fixQuestions(questions[i].actions.questions, allQuestions, indiceFather)
        }
    }
    return questions
}

const fixQuestions = (questionsAction, allQuestions, positionFather) => {
    for (const i in questionsAction) {

        const { name: nameChild } = questionsAction[i]

        const indice = allQuestions.findIndex(({ name }) => name === nameChild)

        if (indice > -1 && positionFather > indice) questionsAction[i].position = indice
        else questionsAction[i] = false

    }

    return questionsAction.filter(question => question)
}

const resetActionsPageCurrent = async () => {
    store.state.questionsByPage = await getQuestionsByPage()
}

export {
    fixPositionQestionsActions
}
